<template>
    <div id="resume_enrollment" :style="{background: `linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 0%, ${colors.second} 500%)`}">
        <auth-header :companyId="companyId"></auth-header>
        <div class="resume_enrollment_content">
            <div class="chatbot_avatar">
                <img src="../../../public/img/brad.png" alt="">
            </div>
            <div class="resume_info">
                <span>Olá! percebi que você já preencheu</span>
                <span>parte do seu cadastro.</span>
                <span>Informe seu e-mail cadastrado</span>
                <span>para continuarmos de onde parou</span>
            </div>
            <div class="auth_form">
                <input type="mail" placeholder="email" v-model="form.email" :style="{color: colors.second}">
                <button v-if="!isLoading" class="btn rounded" :style="{background: `linear-gradient(to right, ${colors.thirth} 0%, ${colors.first} 50%, ${colors.fourth} 100%)`}" @click="auth">Entrar</button>
                <loader v-if="isLoading"></loader>
                <!-- <span @click="logIn()">Já tem cadastro?</span> -->
            </div>
            <div class="copyright">
                <img src="../../../public/img/logo/huddle_copyright.png" alt="Powered by Huddle">
            </div>
            <modal v-if="modal.show" @close="modal.show = false">
                <h3 slot="header">{{modal.title}}</h3>
                <h3 slot="body">{{modal.message}}</h3>
            </modal>
        </div>

    </div>
</template>

<script>
import Modal from '../../components/modals/Modal'
import AuthHeader from '../../components/header/AuthHeader'
import Loader from '../../components/Loaders/CircleLoader'
export default {
    components:{
        modal: Modal,
        'auth-header': AuthHeader,
        loader: Loader
    },
    data: () => ({
        enrollmentId: '',
        enrollment: '',
        companyId: 'yozhmLC3Pf7tapZHUulJ',
        // companyId: '0oBL6uUgbO79BnJlroIb',
        colors: {
            fifth: "#1D5582",
            first: "#DA0334",
            fourth: "#D35556",
            second: "#2C27A3",
            seventh: "#101543",
            sixth: "#7C7C7C",
            thirth: "#A71D68",
        },
        form:{
            email: ''
        },
        modal:{
            show: false,
            title: '',
            message: ''
        },
        isLoading: false,
    }),

    async created(){
        TODO:// Desfixar o  company ID
        this.$store.commit('setColorsState', this.colors)
        await this.getWorkspace()
        localStorage.removeItem('isResumeEnrollmet')
    },
    methods:{
        async getWorkspace(){
            try {
                let workspaceReq = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_SERV_CAT}/workspaces/${this.companyId}`)

                this.companyId = workspaceReq.body.workspace.companyId
                this.colors = workspaceReq.body.workspace.colors
                this.$store.commit('setColorsState', this.colors)
                this.$store.commit('setEssentialInfo',  workspaceReq.body.workspace)
                this.isLoaded = true
                console.log('Company ID: ', this.companyId)
                console.log('workspace REQ: ', this.colors)

            } catch (error) {
                console.error('Erro na requisição de Workspace: ', error);
                
            }
        },

        async auth(){
            this.isLoading = true
            try {
                let enrollmentReq = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_CHATBOT}/enrollments/?email=${this.form.email}`)
                console.log('enrollmentReq: ', enrollmentReq.body)
                if(enrollmentReq.body.length > 1) await this.enrollmentsVerifier(enrollmentReq.body)
                if(enrollmentReq.body.length <= 1) this.enrollment = enrollmentReq.body[0]
                localStorage.setItem('enrollment', JSON.stringify(this.enrollment))
                this.isLoading = false
                this.$router.push('/create-account/')
            } catch (error) {
                this.isLoading = false
                console.error('Erro ao criar/pegar inscrição: ', error.body);
            }
        },
        enrollmentsVerifier(enrollments){
            for (const enrollment of enrollments) {
                if(enrollment.address.cep){
                    this.enrollment = enrollment
                    break
                }
                this.enrollment = enrollments[0]
                console.log('enrollment ID: ', enrollment.id)  
            }
            console.log('enrollment ID: ', this.enrollment.id)

        },
        showModal(title, message){
            this.modal.title = title
            this.modal.message = message
            this.modal.show = true            
        },
    }
}
</script>

<style lang="scss">
    #resume_enrollment{
        .resume_enrollment_content{
            height: 90vh;
            display: flex;
            justify-content: center;
            flex-direction: column;
            background-image: url(../../../public/img/background/pattern-background.png) !important;
            background-size: contain !important;
            background-position: top left!important;


            .chatbot_avatar{
                margin: 0 0 32px 0;
                
                img{
                    max-width: 200px;
                }
            }


            .access_options, .chatbot_avatar{
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            }

            .copyright{
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;

                img{
                    max-width: 60px;
                    margin: 32px 0 0 0;
                }
            }

            .resume_info{
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 90%;
                padding: 0 5% 22px 5%;
                text-align: center;
                font-size: 16px;

                span{
                    text-align: center;
                    letter-spacing: 1px;

                    &:nth-child(2){
                         padding: 0 0 15px 0;
                    }

                }
            }

            .auth_form{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                input{
                    border: 1px solid #ccc;
                    border-radius: 70px;
                    padding: 15px;
                    width: 255px;
                    // width: 60%;
                    margin: 10px auto;

                    &::placeholder{
                        letter-spacing: 2px;
                    }
                }

                span{
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    font-size: 10px;
                    margin: 10px 0 0 0;

                    &:hover{
                        cursor: pointer;
                    }
                }
                .btn.rounded{
                    width: 125px
                }
            }
        }
    }
</style>